module.exports = __webpack_public_path__ + "img/start.e8865291.svg";